import { Alert } from '@heroui/react'
import type { Components } from 'react-markdown'
import Markdown from 'react-markdown'

interface GuideViewerProps {
  contentMd: string
}

const markdownComponents: Components = {
  blockquote: ({ children }) => {
    // In our markdown, warnings usually start with > ⚠️
    return (
      <Alert status="warning" className="my-6">
        <Alert.Indicator />
        <Alert.Content>
          <Alert.Description>{children}</Alert.Description>
        </Alert.Content>
      </Alert>
    )
  },
  img: ({ src, alt }) => {
    return (
      <figure className="my-8 flex flex-col items-center">
        <img
          src={src}
          alt={alt}
          className="max-h-[400px] w-full rounded-lg object-cover shadow-sm"
          loading="lazy"
        />
        {alt && (
          <figcaption className="mt-2 text-sm italic text-default-500">
            {alt}
          </figcaption>
        )}
      </figure>
    )
  },
  h2: ({ children }) => (
    <h2 className="mb-4 mt-8 text-2xl font-bold text-foreground">
      {children}
    </h2>
  ),
  h3: ({ children }) => (
    <h3 className="mb-3 mt-6 text-xl font-semibold text-foreground">
      {children}
    </h3>
  ),
  p: ({ children }) => (
    <p className="mb-4 text-medium leading-relaxed text-default-700">
      {children}
    </p>
  ),
  ul: ({ children }) => (
    <ul className="mb-4 list-inside list-disc space-y-1 text-default-700">
      {children}
    </ul>
  ),
  a: ({ href, children }) => (
    <a
      href={href}
      className="font-medium text-primary hover:underline"
      target="_blank"
      rel="noreferrer"
    >
      {children}
    </a>
  ),
}

export function GuideViewer({ contentMd }: GuideViewerProps) {
  return (
    <div className="mx-auto w-full max-w-3xl">
      <Markdown components={markdownComponents}>{contentMd}</Markdown>
    </div>
  )
}
